var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9969 17.9999V17.9994H17.9999V13.5985C17.9999 11.4455 17.5364 9.78699 15.0195 9.78699C13.8095 9.78699 12.9975 10.451 12.666 11.0805H12.631V9.98799H10.2445V17.9994H12.7295V14.0325C12.7295 12.988 12.9275 11.978 14.221 11.978C15.4955 11.978 15.5145 13.17 15.5145 14.0995V17.9999H17.9969Z",
    fill: "#8F9CBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.198 9.98855H8.68598V18H6.198V9.98855Z",
    fill: "#AAAFBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44099 6C6.6455 6 6 6.6455 6 7.44099C6 8.23649 6.6455 8.89548 7.44099 8.89548C8.23649 8.89548 8.88198 8.23649 8.88198 7.44099C8.88148 6.6455 8.23599 6 7.44099 6Z",
    fill: "#8F9CBC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "#AAAFBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.e01e62ca.svg";
export { ForwardRef as ReactComponent };